import type { CSSProperties } from "react";
import React from "react";
import translate from "src/lib/translate";
import { ProfileProgramMembership } from "src/constants/programs";
import type { CustomizedCheckoutScreenContentProps } from "src/ui/components/SignupCustomContent/state/CustomizedCheckoutScreenBloc";
import Translate from "src/ui/components/Translate/Translate";
import Highlights from "src/ui/styled/Highlights";
import { Container, List, ListElement, ListWrapper } from "src/ui/styled/List";
import NoteSection from "./NoteSection";

export const CheckoutContentWeightManagement: CustomizedCheckoutScreenContentProps =
  {
    imageSrc:
      "https://d3a2es9lb3nmct.cloudfront.net/img/9ddef9c02b6859f2abdedd61fa2d695595086333-1374x768.jpg?w=800&auto=format",
    image: () => (
      <img
        src={
          "https://d3a2es9lb3nmct.cloudfront.net/img/9ddef9c02b6859f2abdedd61fa2d695595086333-1374x768.jpg?w=800&auto=format"
        }
        className="rounded-small aspect"
        style={{ "--img-aspect": "458/256" } as CSSProperties}
        alt={translate(
          `program.title_${ProfileProgramMembership.HEALTHY_WEIGHT_JOURNEY}`
        )}
      ></img>
    ),
    title: () => (
      <Translate
        msg={`program.title_${ProfileProgramMembership.HEALTHY_WEIGHT_JOURNEY}`}
      />
    ),
    subtitle: () => (
      <Translate
        msg={`program.description_${ProfileProgramMembership.HEALTHY_WEIGHT_JOURNEY}`}
      />
    ),
    highlights: () => (
      <Highlights>
        <ul>
          <li>
            <img src="https://d3a2es9lb3nmct.cloudfront.net/img/d7d49e4d77811f9ce2852641c170a47cde926dbf-20x20.svg" />
            <Translate msg="benefit.personalizedPlan" />
          </li>
          <li>
            <img src="https://d3a2es9lb3nmct.cloudfront.net/img/bac9228b8960e98885b933a6b994ec6dee22de7e-20x20.svg" />
            <Translate msg="benefit.medicationTherapy" />
          </li>
          <li>
            <img src="https://d3a2es9lb3nmct.cloudfront.net/img/e0f2240b106df7cf0b90806bb095236035476015-20x20.svg" />
            <Translate msg="benefit.onDemandCare" />
          </li>
          <li>
            <img src="https://d3a2es9lb3nmct.cloudfront.net/img/1cad4c0a79c555e11ad2a0da8c6a3393f8245b02-20x20.svg" />
            <Translate msg="benefit.goalsProgressTracking" />
          </li>
        </ul>
      </Highlights>
    ),
    list: () => (
      <Container>
        <div style={{ position: "relative" }}>
          <ListWrapper>
            <h6 className="as-body2">
              <Translate msg="benefit.onboarding.title" />
            </h6>
            <List className="m0">
              <ListElement className="m0">
                <Translate msg="benefit.onlineHealthAssessment" />
              </ListElement>
              <ListElement>
                <Translate msg="benefit.metabolicLabTest" />
              </ListElement>
              <ListElement>
                <Translate msg="benefit.personalizedPlanDevelopment" />
              </ListElement>
              <ListElement>
                <Translate msg="benefit.doctorVisit" />
              </ListElement>
              <ListElement>
                <Translate msg="benefit.prescriptions" />
              </ListElement>
              <ListElement>
                <Translate msg="benefit.insuranceNavigation" />
              </ListElement>
            </List>
          </ListWrapper>
        </div>

        <div style={{ position: "relative" }}>
          <ListWrapper>
            <h6 className="as-body2">Ongoing care</h6>
            <List className="m0">
              <ListElement className="m0">
                <Translate msg="benefit.accessToSpecialists" />
              </ListElement>
              <ListElement>
                <Translate msg="benefit.ongoingCheckins" />
              </ListElement>
              <ListElement>
                <Translate msg="benefit.metabolicLabTest" />
              </ListElement>
              <ListElement>
                <Translate msg="benefit.prescriptionsManagement" />
              </ListElement>
              <ListElement>
                <Translate msg="benefit.behavioralLifestyleCoaching" />
              </ListElement>
              <ListElement>
                <Translate msg="benefit.connectedWeightScale" />
              </ListElement>
            </List>
          </ListWrapper>
        </div>
      </Container>
    ),
    note: (options) => (
      <NoteSection
        profileProgramMembership={
          ProfileProgramMembership.HEALTHY_WEIGHT_JOURNEY
        }
        selfPayed={false}
        rpmConditions={options.eligibleFoeMedicalBilling}
      />
    )
  };
